import DemoTransactionsTable from './DemoTransactionsTable'

export default DemoTransactionsTable
